import { useContext } from 'react';
import { EffectContext } from '../../../../../common/view/effect/effect.context';
import { MonoIcon } from '../../../../../common/view/icon/mono/mono-icon';
import { ImmerFuncs } from '../../../../../external/immer/immer.funcs';
import { ServerApi } from '../../../../../external/server/server.api';
import { ArrayFuncs } from '../../../../../foundation/js/array.funcs';
import { EffectTypeWire } from '../../../../core/effect/effect-type.wire';
import { EffectWireFuncs } from '../../../../core/effect/effect.wire.func';
import { ProgressEffectDataWire } from '../../../../core/effect/effects/progress/progress-effect-data.wire';
import { NodeStore } from '../../../../core/node/node.store';
import { EffectMenuItem } from '../../effect-menu-item';
import { ProgressEffectTotalEditModal } from './progress-effect-total-edit-modal';

export function ProgressEffectMenuItem({ nodeId }: { nodeId: string }) {
  const node = NodeStore.useItem(nodeId);
  const effect = ArrayFuncs.ensure(node.effects).find((e) => e.type === EffectTypeWire.progress);
  const { modalApi, popupApi } = useContext(EffectContext);

  if (effect) {
    return null;
  }

  async function handleClick() {
    popupApi.pop();

    let newEffect = EffectWireFuncs.init<ProgressEffectDataWire>({
      type: EffectTypeWire.progress,
      data: {
        current: 0,
        total: 10,
      },
    });

    newEffect = await new Promise((resolve) => {
      modalApi.push({
        component: (
          <ProgressEffectTotalEditModal
            effect={newEffect}
            onOk={(e) => {
              resolve(e);
            }}
          />
        ),
      });
    });

    modalApi.pop();
    const effects = ArrayFuncs.ensure(node.effects);
    const newEffects = ImmerFuncs.produce(effects, (draft) => {
      EffectWireFuncs.addEffect({ effects: draft, effect: newEffect });
    });
    NodeStore.updateItem(nodeId, { effects: newEffects });
    ServerApi.updateNode(nodeId, { effects: newEffects });
  }

  return (
    <EffectMenuItem icon={MonoIcon.progress} iconColor={'#007FFF'} title={'Track Progress'} subtitle={'Watched 10 / 113 of the video'} onClick={handleClick} />
  );
}
